<template>
	<div v-if="cd" class="c-countdown">
		<slot></slot>
		<span>{{cd.day}}天{{cd.hour}}时{{cd.min}}分{{cd.sec}}秒</span>
	</div>
</template>

<script>
	import fun from '@/assets/script/function.js'
	
	export default {
		props: {
			date: String
		},
		
		data() {
			return {
				cd: ''
			}
		},
		
		watch: {
			date() {
				this.countdown();
			}
		},
		
		mounted() {
			this.countdown();
		},
		
		methods: {
			countdown() {
				if (!this.date) return;
				
				this._countdown && this._countdown.abort();
				this._countdown = fun.countdown(this.date, item => {
					this.cd = item;
				}, () => {
					this.$emit('end');
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-countdown {
		font-size: 16px;
		color: #E63633;
		
		elder({
			font-size: 22px
		})
	}
</style>
